export default __webpack_public_path__ + "static/media/spaces.3e9ce7bc.jpg";